<template>
  <div class="pick-input anCore-tabPage-body" v-loading="loading">
    <!-- 对齐 Ivan AnCore/Wf/ToolBar.html -->
    <div data-id="wfToolBar" class="form-inline" style="display:block;">
      <div class="bg-info pick-input__toolbar">
        <div style="display:inline-block;">
          <span style="display:inline-block;margin-right:4px;">
            <button class="btn btn-info hidden-xs" type="button" title="上传附件" @click="onAttach">
              <i class="fa fa-upload" />
              <span>附件</span>
            </button>
          </span>
          <span style="display:inline-block;margin-right:4px;">
            <button class="btn btn-primary hidden-xs" type="button" @click="onTransfer">
              <i class="fa fa-share" />
              <span>转交</span>
            </button>
          </span>
          <span style="display:inline-block;margin-right:4px;">
            <button class="btn btn-success hidden-xs" type="button" :disabled="saving" @click="onSave">
              <i class="fa fa-save" />
              <span>暂存</span>
            </button>
          </span>
          <span style="display:inline-block;margin-right:4px;">
            <button
              class="btn btn-danger hidden-xs"
              type="button"
              :disabled="auditDone"
              @click="onBack"
            >
              <i class="fa fa-reply" />
              <span>退回</span>
            </button>
          </span>
          <span class="btn-group has-feedback hidden-xs" style="display:inline-block;margin-right:4px;vertical-align:middle;">
            <button
              class="btn btn-primary"
              type="button"
              :disabled="submitting || auditDone"
              @click="onSubmit"
            >
              <i class="fa fa-send" />
              <span>{{ auditMode ? (auditDone ? '已审核' : '审核通过') : '提交' }}</span>
            </button>
          </span>
        </div>
      </div>
    </div>

    <!-- 审阅意见左 + 签名预览右 -->
    <div data-id="tempWfDiv" class="pick-input__comment">
      <div class="pick-input__comment-main">
        <span class="help-block pick-input__label">审阅意见：</span>
        <textarea
          class="form-control"
          rows="3"
          placeholder="请输入……"
          v-model="comment"
        />
      </div>
      <div class="pick-input__sign">
        <div class="pick-input__sign-head">
          <span class="help-block pick-input__label">审核签名：</span>
          <button class="btn btn-xs btn-link" type="button" @click="onSign">
            <i class="fa fa-edit" />{{ auditorSign ? '重签' : '扫码签名' }}
          </button>
        </div>
        <div class="pick-input__sign-pad" @click="onSign" title="点击扫码签名">
          <img
            v-if="signMediaUrl"
            :src="signMediaUrl"
            class="pick-input__sign-img"
            alt="审核签名"
          />
          <span v-else class="pick-input__sign-empty">点击扫码签名</span>
        </div>
      </div>
    </div>

    <div data-id="bizForm" class="anCore-bizForm">
      <div data-id="panelForm" style="padding-bottom:5px;">
        <div class="panel panel-info">
          <div class="panel-heading">
            <span>采样信息</span>
            <span class="pull-right" style="display:inline-block;margin-top:-5px;">
              <button class="btn btn-default btn-sm" type="button" @click="onPhotos">
                <i class="fa fa-image" />现场照片
                <span v-if="photos.length" class="text-danger">{{ photos.length }}</span>
              </button>
              <button class="btn btn-default btn-sm" type="button" @click="onEntrust">
                <i class="fa fa-flag" />查看受理单
              </button>
            </span>
          </div>
          <div class="panel-body">
            <!-- 与 App 一致：现场在前、分析在后 -->
            <div class="panel panel-primary">
              <div class="panel-heading"><span>现场采样记录</span></div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>点位</th>
                    <th>现场摘要</th>
                    <th>项目</th>
                    <th>结果</th>
                    <th style="width:110px;" class="text-center">
                      <button
                        v-if="!readonly"
                        class="btn btn-success btn-sm"
                        type="button"
                        @click="openLiveEdit(null)"
                      >
                        <i class="fa fa-plus" />新增
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in visibleLive" :key="'live-' + idx">
                    <td>{{ row.MonitorSitePlace || '—' }}</td>
                    <td class="text-muted small" style="max-width:280px;word-break:break-all;">{{ liveSummary(row) }}</td>
                    <td>{{ liveItemNames(row) }}</td>
                    <td>{{ row.MonitorValue == null || row.MonitorValue === '' ? '—' : row.MonitorValue }}</td>
                    <td>
                      <div v-if="!readonly">
                        <button class="btn btn-link btn-sm" type="button" title="编辑" @click="openLiveEdit(row)">
                          <i class="fa fa-edit" />
                        </button>
                        <button class="btn btn-link btn-sm" type="button" title="删除" @click="removeLive(row)">
                          <i class="fa fa-trash-o text-muted" />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="!visibleLive.length" class="text-center text-muted" style="padding:25px 0;">
                <span>无数据</span>
              </div>
            </div>

            <div class="panel panel-primary">
              <div class="panel-heading"><span>分析样品</span></div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>点位</th>
                    <th>瓶条码</th>
                    <th>分析项目</th>
                    <th style="width:110px;" class="text-center">
                      <button
                        v-if="!readonly"
                        class="btn btn-success btn-sm"
                        type="button"
                        @click="openLabEdit(null)"
                      >
                        <i class="fa fa-plus" />新增
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in visibleLab" :key="'lab-' + idx">
                    <td>{{ row.MonitorSitePlace || '—' }}</td>
                    <td><span>{{ row.BarCode || '—' }}</span></td>
                    <td>{{ row.InspectItemNames || '—' }}</td>
                    <td>
                      <div v-if="!readonly">
                        <button class="btn btn-link btn-sm" type="button" title="编辑" @click="openLabEdit(row)">
                          <i class="fa fa-edit" />
                        </button>
                        <button class="btn btn-link btn-sm" type="button" title="删除" @click="removeLab(row)">
                          <i class="fa fa-trash-o text-muted" />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="!visibleLab.length" class="text-center text-muted" style="padding:25px 0;">
                <span>无数据（App 中分析为选填）</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="'样品信息'"
      :visible.sync="editVisible"
      width="640px"
      append-to-body
      @close="editForm = emptyForm()"
    >
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-sm-3 control-label">点位</label>
          <div class="col-sm-9">
            <input class="form-control" v-model="editForm.MonitorSitePlace" placeholder="监测点位" />
          </div>
        </div>
        <div class="form-group" v-if="editIsLive">
          <label class="col-sm-3 control-label">频次</label>
          <div class="col-sm-9">
            <input class="form-control" type="number" min="1" v-model.number="editForm.FrequencyTimeIndex" placeholder="第几次" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">{{ editIsLive ? '编码' : '瓶条码' }}</label>
          <div class="col-sm-9">
            <input class="form-control" v-model="editForm.BarCode" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">{{ editIsLive ? '现场项目' : '分析项目' }}</label>
          <div class="col-sm-9">
            <input
              class="form-control"
              v-model="editForm[editIsLive ? 'LiveInspectItemNames' : 'InspectItemNames']"
            />
          </div>
        </div>
        <div class="form-group" v-if="editIsLive">
          <label class="col-sm-3 control-label">结果值</label>
          <div class="col-sm-9">
            <input class="form-control" v-model="editForm.MonitorValue" placeholder="现场测定结果" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmEdit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="现场照片" :visible.sync="photoVisible" width="720px" append-to-body>
      <div v-if="!photos.length" class="text-muted text-center" style="padding:24px;">暂无现场照片</div>
      <div v-else class="pick-photo-grid">
        <div v-for="(p, i) in photos" :key="'ph-' + i" class="pick-photo-card">
          <el-image
            :src="photoUrl(p)"
            fit="contain"
            class="pick-photo-img"
            :preview-src-list="photoPreviewList"
          />
          <div class="pick-photo-name">{{ p.name || ('照片' + (i + 1)) }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="photoVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <HandSignDialog
      v-model="signVisible"
      :existing-url="signMediaUrl"
      :xmbh="xmbh"
      :task-id="taskId"
      @signed="onSigned"
    />
  </div>
</template>

<script>
import api from '@/utils/api'
import HandSignDialog from '@/components/ivan/HandSignDialog.vue'
import { pingTodoRefresh as notifyTodoChanged } from '@/utils/todoSync'

const LS_PREFIX = 'yn_pick_input_'

function storageKey(xmbh, taskId) {
  return LS_PREFIX + String(xmbh || 'demo') + '_' + String(taskId || 'default')
}

export default {
  name: 'PickInput',
  components: { HandSignDialog },
  data() {
    return {
      loading: false,
      saving: false,
      submitting: false,
      readonly: false,
      caseTitle: '',
      xmbh: '',
      taskId: '',
      inspectType: '',
      status: 'draft',
      sampleList: [],
      liveList: [],
      photos: [],
      comment: '',
      auditorSign: '',
      editVisible: false,
      editIsLive: false,
      editTarget: null,
      editForm: {
        MonitorSitePlace: '',
        BarCode: '',
        InspectItemNames: '',
        LiveInspectItemNames: '',
        FrequencyTimeIndex: 1,
        MonitorValue: '',
        IsRemove: false
      },
      photoVisible: false,
      signVisible: false
    }
  },
  computed: {
    visibleLab() {
      return (this.sampleList || []).filter(r => !r.IsRemove)
    },
    visibleLive() {
      return (this.liveList || []).filter(r => !r.IsRemove)
    },
    photoPreviewList() {
      return (this.photos || []).map(p => this.photoUrl(p)).filter(Boolean)
    },
    signMediaUrl() {
      return this.resolveMediaUrl(this.auditorSign)
    },
    auditMode() {
      return String((this.$route.query && this.$route.query.mode) || '') === 'audit'
    },
    /** 已审完：工具栏只保留查看，不可再通过/退回 */
    auditDone() {
      return this.status === 'audited'
    }
  },
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        this.bootstrap()
      }
    }
  },
  mounted() {
    this.bootstrap()
  },
  methods: {
    isAuditMode() {
      return String((this.$route.query && this.$route.query.mode) || '') === 'audit'
    },
    liveItemNames(row) {
      if (!row) return '—'
      return row.LiveInspectItemNames || row.InspectItemNames || '—'
    },
    liveSummary(row) {
      if (!row) return '—'
      const parts = []
      if (row.jwd) parts.push('坐标 ' + row.jwd)
      if (row.sd) parts.push('深度 ' + row.sd)
      if (row.ys) parts.push(row.ys)
      if (row.trzd) parts.push(row.trzd)
      if (row.sd2) parts.push(row.sd2)
      if (row.FrequencyTimeIndex) parts.push('第' + row.FrequencyTimeIndex + '次')
      if (row.BarCode) parts.push('编码 ' + row.BarCode)
      return parts.length ? parts.join(' · ') : '—'
    },
    emptyForm() {
      return {
        MonitorSitePlace: '',
        BarCode: '',
        InspectItemNames: '',
        LiveInspectItemNames: '',
        FrequencyTimeIndex: 1,
        MonitorValue: '',
        IsRemove: false
      }
    },
    normalizeLists(sampleList, liveList) {
      const labs = (Array.isArray(sampleList) ? sampleList : []).map(r => ({ ...r }))
      const lives = (Array.isArray(liveList) ? liveList : []).map(r => {
        const row = { ...r }
        if (!row.LiveInspectItemNames && row.InspectItemNames) {
          row.LiveInspectItemNames = row.InspectItemNames
        }
        return row
      })
      return { labs, lives }
    },
    applyRecord(rec) {
      if (!rec || typeof rec !== 'object') return
      this.xmbh = rec.xmbh || this.xmbh
      this.taskId = rec.taskId || this.taskId
      this.caseTitle = rec.title || this.caseTitle
      this.inspectType = rec.inspectType || this.inspectType
      this.status = rec.status || 'draft'
      const { labs, lives } = this.normalizeLists(rec.SampleList, rec.LiveResultSampleList)
      this.sampleList = labs
      this.liveList = lives
      this.photos = this.normalizePhotos(rec.photos)
      this.comment = rec.comment != null ? (rec.comment || '') : this.comment
      // 服务端未回手签时不要清空本地刚签的图
      if (Object.prototype.hasOwnProperty.call(rec, 'auditorSign') && rec.auditorSign) {
        this.auditorSign = rec.auditorSign
      } else if (rec.auditorSign === '' && !this.auditorSign) {
        this.auditorSign = ''
      }
      if (this.isAuditMode()) this.readonly = true
    },
    normalizePhotos(list) {
      if (!Array.isArray(list)) return []
      return list.map((p, i) => {
        if (typeof p === 'string') return { path: p, name: '照片' + (i + 1) }
        if (!p || typeof p !== 'object') return null
        return {
          ...p,
          path: p.path || p.wjlj || p.url || '',
          name: p.name || p.wjmc || ('照片' + (i + 1))
        }
      }).filter(Boolean)
    },
    cacheLocal() {
      const payload = {
        sampleList: this.sampleList,
        liveList: this.liveList,
        photos: this.photos,
        comment: this.comment,
        auditorSign: this.auditorSign,
        status: this.status,
        updatedAt: Date.now()
      }
      try {
        localStorage.setItem(storageKey(this.xmbh, this.taskId), JSON.stringify(payload))
      } catch (e) { /* ignore */ }
    },
    pingTodoRefresh() {
      notifyTodoChanged()
    },
    buildPayload(extra) {
      const ex = extra || {}
      const skipLists = !!ex.skipLists
      const payload = {
        xmbh: this.xmbh,
        taskId: this.taskId,
        title: this.caseTitle,
        inspectType: this.inspectType,
        status: this.status,
        comment: this.comment,
        auditorSign: this.auditorSign
      }
      if (!skipLists) {
        payload.SampleList = this.sampleList
        payload.LiveResultSampleList = this.liveList
        payload.photos = this.photos
      }
      Object.keys(ex).forEach(k => {
        if (k === 'skipLists') return
        payload[k] = ex[k]
      })
      return payload
    },
    async bootstrap() {
      const q = this.$route.query || {}
      const audit = String(q.mode || '') === 'audit'
      this.xmbh = q.xmbh || ''
      this.taskId = q.taskId || q.rowId || ''
      this.caseTitle = q.name || q.title || '采样信息'
      this.inspectType = q.inspectType || q.type || ''
      this.readonly = q.readonly === '1' || q.readonly === 'true' || audit
      const bootId = (this._bootSeq = (this._bootSeq || 0) + 1)
      this.loading = true
      try {
        if (this.xmbh || this.taskId) {
          const res = await api.get('yn_pick_get', {
            xmbh: this.xmbh,
            taskId: this.taskId,
            title: this.caseTitle,
            inspectType: this.inspectType,
            _t: Date.now()
          })
          if (bootId !== this._bootSeq) return
          const data = res && res.data
          if (data && data.ok && data.record) {
            const rec = data.record
            const hasRemote =
              (Number(rec.id) > 0) ||
              (Array.isArray(rec.SampleList) && rec.SampleList.some(r => r && !r.IsRemove)) ||
              (Array.isArray(rec.LiveResultSampleList) && rec.LiveResultSampleList.some(r => r && !r.IsRemove))
            if (hasRemote) {
              this.applyRecord(rec)
              this.cacheLocal()
              return
            }
          }
        }
        if (bootId !== this._bootSeq) return
        // 审核态：禁止演示假数据，避免和 App 对不上
        if (audit) {
          this.sampleList = []
          this.liveList = []
          this.photos = []
          this.comment = ''
          this.status = 'draft'
          this.$message.warning('未拉到 App 提交的采样数据，请确认 taskId / 网络')
          return
        }
        const raw = localStorage.getItem(storageKey(this.xmbh, this.taskId))
        if (raw) {
          const saved = JSON.parse(raw)
          this.sampleList = saved.sampleList || []
          this.liveList = saved.liveList || []
          this.photos = saved.photos || []
          this.comment = saved.comment || ''
          this.auditorSign = saved.auditorSign || ''
          this.status = saved.status || 'draft'
          if (!this.visibleLab.length && !this.visibleLive.length && (q.place || q.item || q.code)) {
            this.seedDemo()
          }
        } else {
          this.seedDemo()
        }
      } catch (e) {
        if (bootId !== this._bootSeq) return
        if (audit) {
          this.sampleList = []
          this.liveList = []
          this.$message.error('加载 App 采样数据失败')
          return
        }
        try {
          const raw = localStorage.getItem(storageKey(this.xmbh, this.taskId))
          if (raw) {
            const saved = JSON.parse(raw)
            this.sampleList = saved.sampleList || []
            this.liveList = saved.liveList || []
            this.photos = saved.photos || []
            this.comment = saved.comment || ''
            this.auditorSign = saved.auditorSign || ''
          } else {
            this.seedDemo()
          }
        } catch (e2) {
          this.seedDemo()
        }
      } finally {
        if (bootId === this._bootSeq) this.loading = false
      }
    },
    seedDemo() {
      if (this.isAuditMode()) return
      const place = this.$route.query.place || '厂界四周'
      const item = this.$route.query.item || '厂界噪声'
      const code = this.$route.query.code || (this.xmbh ? `${this.xmbh}-ZS-1` : 'WT-DEMO-ZS-1')
      this.sampleList = []
      this.liveList = [
        {
          MonitorSitePlace: place,
          FrequencyTimeIndex: 1,
          BarCode: code,
          LiveInspectItemNames: item,
          MonitorValue: '-',
          IsRemove: false
        }
      ]
      this.photos = []
      this.comment = ''
      this.status = 'draft'
    },
    async persistRemote(submit, extra) {
      this.cacheLocal()
      const action = submit ? 'yn_pick_submit' : 'yn_pick_save'
      const res = await api.postJson(action, this.buildPayload(extra))
      const data = res && res.data
      if (data && data.ok && data.record) {
        if (extra && extra.skipLists) {
          if (data.record.auditorSign) this.auditorSign = data.record.auditorSign
          if (data.record.comment != null) this.comment = data.record.comment
        } else {
          this.applyRecord(data.record)
        }
        this.cacheLocal()
      }
      return data
    },
    openLabEdit(row) {
      this.editIsLive = false
      this.editTarget = row || null
      this.editForm = row
        ? { ...this.emptyForm(), ...row }
        : { ...this.emptyForm(), MonitorSitePlace: this.$route.query.place || '' }
      this.editVisible = true
    },
    openLiveEdit(row) {
      this.editIsLive = true
      this.editTarget = row || null
      this.editForm = row
        ? { ...this.emptyForm(), ...row }
        : {
            ...this.emptyForm(),
            MonitorSitePlace: this.$route.query.place || '',
            FrequencyTimeIndex: 1
          }
      this.editVisible = true
    },
    async confirmEdit() {
      const model = { ...this.editForm, IsRemove: false }
      const list = this.editIsLive ? this.liveList : this.sampleList
      if (this.editTarget) {
        const real = list.indexOf(this.editTarget)
        if (real >= 0) this.$set(list, real, model)
        else list.push(model)
      } else {
        list.push(model)
      }
      this.editVisible = false
      this.editTarget = null
      try {
        await this.persistRemote(false)
      } catch (e) {
        this.cacheLocal()
      }
    },
    async removeLab(row) {
      if (!confirm('确定移除该数据吗？')) return
      const real = this.sampleList.indexOf(row)
      if (real >= 0) this.$set(this.sampleList[real], 'IsRemove', true)
      try {
        await this.persistRemote(false)
      } catch (e) {
        this.cacheLocal()
      }
    },
    async removeLive(row) {
      if (!confirm('确定移除该数据吗？')) return
      const real = this.liveList.indexOf(row)
      if (real >= 0) this.$set(this.liveList[real], 'IsRemove', true)
      try {
        await this.persistRemote(false)
      } catch (e) {
        this.cacheLocal()
      }
    },
    onAttach() {
      this.$message.info('附件上传（界面占位，后续对接）')
    },
    onTransfer() {
      this.$message.info('转交（界面占位，后续对接）')
    },
    async onSave() {
      this.saving = true
      try {
        const data = await this.persistRemote(false)
        if (data && data.ok === 0) {
          this.$message.error(data.error || '暂存失败')
        } else {
          this.$message.success('已暂存')
        }
      } catch (e) {
        this.cacheLocal()
        this.$message.warning('网络异常，已存本地')
      } finally {
        this.saving = false
      }
    },
    async onBack() {
      if (!confirm('确认退回给采样员？')) return
      this.saving = true
      try {
        this.status = 'returned'
        const data = await this.persistRemote(false, { status: 'returned' })
        if (data && data.ok === 0) {
          this.$message.error(data.error || '退回失败')
        } else {
          this.$message.success('已退回')
        }
      } catch (e) {
        this.cacheLocal()
        this.$message.warning('网络异常，状态已改本地')
      } finally {
        this.saving = false
      }
    },
    async onSubmit() {
      // 审核页：通过 = audited；勿走 yn_pick_submit（会再次写成 pending_audit）
      if (this.auditMode) {
        await this.onAuditPass()
        return
      }
      if (!this.visibleLab.length && !this.visibleLive.length) {
        this.$message.warning('请至少新增一条样品')
        return
      }
      this.submitting = true
      try {
        const data = await this.persistRemote(true)
        if (data && data.ok === 0) {
          this.$message.error(data.error || '提交失败')
        } else {
          this.$message.success('已提交待审')
          this.pingTodoRefresh()
        }
      } catch (e) {
        this.cacheLocal()
        this.$message.warning('网络异常，已存本地')
      } finally {
        this.submitting = false
      }
    },
    async onAuditPass() {
      if (this.auditDone) {
        this.$message.info('该采样已审核通过')
        return
      }
      if (!this.auditorSign) {
        this.$message.warning('请先完成手签，再点「审核通过」')
        return
      }
      if (!confirm('确认审核通过？通过后本任务显示为「已完成采样」。')) return
      this.submitting = true
      try {
        this.status = 'audited'
        const data = await this.persistRemote(false, {
          status: 'audited',
          skipLists: true
        })
        if (data && data.ok === 0) {
          this.status = 'pending_audit'
          this.$message.error(data.error || '审核通过失败')
          return
        }
        const savedStatus = data && data.record && data.record.status
        if (savedStatus && savedStatus !== 'audited') {
          this.status = savedStatus
          this.$message.error('审核状态未写入（当前仍为' + savedStatus + '），请重试')
          return
        }
        if (data && data.record) {
          this.status = 'audited'
          if (data.record.auditorSign) this.auditorSign = data.record.auditorSign
        }
        this.cacheLocal()
        const hand = data && data.handover
        const who = (hand && (hand.next_handler || hand.next)) || '综合部主任'
        this.$message.success('审核已通过（已完成采样），已自动进入样品管理 → ' + who)
        this.pingTodoRefresh()
        // 回外层列表；样品管理由综合部主任在 PC「样品管理」菜单处理
        await this.$router.replace({
          path: '/pick/batch-contract',
          query: { xmbh: this.xmbh || undefined, _r: String(Date.now()) }
        })
      } catch (e) {
        this.status = 'pending_audit'
        this.cacheLocal()
        this.$message.warning('网络异常，状态未同步')
      } finally {
        this.submitting = false
      }
    },
    onSign() {
      this.signVisible = true
    },
    async onSigned(payload) {
      let signVal = ''
      const raw = typeof payload === 'string' ? payload : ''
      // 扫码会话已落盘：直接是 uploads/... 路径；旧 dataURL 仍走上传
      if (raw && !/^data:/i.test(raw) && (raw.indexOf('uploads/') === 0 || raw.indexOf('/uploads/') >= 0)) {
        signVal = raw.replace(/^\//, '')
      } else {
        try {
          const blob = await (await fetch(raw)).blob()
          const file = new File([blob], 'pick-auditor-sign.png', { type: 'image/png' })
          const up = await api.upload('yn_upload', file, { sl_id: 0 })
          const data = up && up.data
          if (typeof data === 'string' && data.indexOf('22|') === 0) {
            throw new Error(data.slice(3) || '上传失败')
          }
          const path = data && data.path
          if (!path) throw new Error('上传未返回路径')
          signVal = path
        } catch (e) {
          this.$message.error((e && e.message) || '手签上传失败，请重试')
          return
        }
      }
      this.auditorSign = signVal
      try {
        const data = await this.persistRemote(false, {
          auditorSign: signVal,
          skipLists: true
        })
        if (data && data.ok === 0) {
          this.$message.error(data.error || '手签保存失败')
          return
        }
        if (data && data.record && data.record.auditorSign) {
          this.auditorSign = data.record.auditorSign
        }
        this.$message.success('手签已保存')
      } catch (e) {
        this.cacheLocal()
        this.$message.warning('网络异常，手签已存本地')
      }
    },
    resolveMediaUrl(p) {
      if (!p) return ''
      if (typeof p === 'string') {
        const s = p.trim()
        if (!s) return ''
        if (/^(https?:|data:|blob:)/i.test(s)) return s
        return 'http://bg.yasenkj.cn/' + s.replace(/^\//, '').replace(/\\/g, '/')
      }
      const raw = String(p.url || p.path || p.wjlj || '').trim()
      if (!raw) return ''
      if (/^(https?:|data:|blob:)/i.test(raw)) return raw
      return 'http://bg.yasenkj.cn/' + raw.replace(/^\//, '').replace(/\\/g, '/')
    },
    photoUrl(p) {
      return this.resolveMediaUrl(p)
    },
    onPhotos() {
      this.photoVisible = true
    },
    onEntrust() {
      if (this.xmbh) {
        this.$router.push({ path: '/entrust/' + encodeURIComponent(this.xmbh) })
        return
      }
      this.$message.info('未关联项目编号，无法打开受理单')
    }
  }
}
</script>

<style scoped>
/* 对齐 Ivan .anCore-tabPage-body */
.pick-input.anCore-tabPage-body {
  padding: 10px 15px 10px 25px;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
}
.pick-input__toolbar {
  padding: 5px;
  min-height: 45px;
}
/* 审阅意见 | 审核签名 左右两栏，等高；签名区加宽 */
.pick-input__comment {
  display: flex;
  align-items: stretch;
  gap: 16px;
  padding-top: 10px;
  padding-bottom: 8px;
}
.pick-input__comment-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.pick-input__comment-main textarea {
  resize: vertical;
  flex: 1 1 auto;
  min-height: 96px;
  height: 96px;
  box-sizing: border-box;
}
.pick-input__label {
  margin: 0 0 4px;
  display: inline-block;
  line-height: 22px;
  height: 22px;
}
.pick-input__sign {
  flex: 0 0 320px;
  width: 320px;
  max-width: 38%;
  display: flex;
  flex-direction: column;
}
.pick-input__sign-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 22px;
  margin-bottom: 4px;
}
.pick-input__sign-head .btn-link {
  padding: 0 2px;
  line-height: 1.2;
}
.pick-input__sign-pad {
  flex: 1 1 auto;
  min-height: 96px;
  height: 96px;
  border: 1px solid #ccc;
  border-radius: 2px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  padding: 6px 10px;
  box-sizing: border-box;
}
.pick-input__sign-pad:hover {
  border-color: #66afe9;
}
.pick-input__sign-img {
  max-width: 100%;
  max-height: 84px;
  object-fit: contain;
  display: block;
}
.pick-input__sign-empty {
  color: #999;
  font-size: 12px;
  user-select: none;
}
.pick-input .panel-primary {
  margin-bottom: 15px;
}
.pick-input .panel-primary > .table {
  margin-bottom: 0;
}
.pick-input .form-group {
  margin-bottom: 12px;
}
.pick-photo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.pick-photo-card {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
  background: #fafafa;
}
.pick-photo-img {
  width: 100%;
  height: 160px;
  display: block;
}
.pick-photo-name {
  padding: 6px 8px;
  font-size: 12px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
